/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-03-14 10:52:09.

export interface Adress {
  /**
   * Gatuadress
   */
  gata: string;
  /**
   * Lägenhetsnummer
   */
  lagenhetsnummer: string;
  /**
   * Postnummer
   */
  postnummer: string;
  /**
   * Postort
   */
  postort: string;
}

export interface BostadAutocompleteDto {
  id: number;
  text: string;
  kommun: string;
  postort: string;
  lagenhetsnummer: string;
  selectable: boolean;
}

export interface BostadsinformationDto {
  id: number;
  adress: string;
  lagenhetsnummer: string;
  kommun: string;
  postort: string;
  postnummer: string;
  boarea: number;
  antalRum: number;
  byggar: number;
  bostadstyp: Bostadstyp;
  sweref99x: number;
  sweref99y: number;
  agandeform: Agandeform;
  kallTyp: KallTyp;
}

export interface BostadsvarderingDto
  extends RepresentationModel<BostadsvarderingDto> {
  /**
   * Id för bostadsvärderingen.
   */
  id: string;
  /**
   * Tidpunkt när värderingen skapades.
   */
  skapadTidpunkt: DateAsString;
  /**
   * Tidpunkt när värderingen uppdaterades.
   */
  uppdateradTidpunkt: DateAsString;
  /**
   * Kundmarken för värderingen.
   */
  kundmarke: string;
  vardering: Vardering;
  parametrar: VarderingParametrarDto;
  adress: Adress;
  referensforsaljningar: Referensforsaljning[];
  omvardering: Omvardering;
}

export interface Omvardering {
  /**
   * Antal omvärderingar.
   */
  antalOmvarderingar: number;
  /**
   * Maximalt antal omvärderingar.
   */
  maxAntalOmvarderingar: number;
  /**
   * Tidpunkt när omvärderingen kan genomföras till.
   */
  kanOmvarderasTill: DateAsString;
}

export interface Referensforsaljning {
  /**
   * Adress för referensförsäljningen.
   */
  adress: string;
  /**
   * Antal rum i referensförsäljningen.
   */
  antalRum: number;
  /**
   * Boarea i referensförsäljningen.
   */
  boarea: number;
  /**
   * Biarea i referensförsäljningen.
   */
  biarea: number;
  /**
   * Tomtarea i referensförsäljningen.
   */
  tomtarea: number;
  /**
   * Genomsnittlig avgift i referensförsäljningen.
   */
  avgift: number;
  /**
   * Våning i referensförsäljningen.
   */
  vaning: number;
  /**
   * Antal våningar i referensförsäljningen.
   */
  antalVaningar: number;
  /**
   * År då referensförsäljningen byggdes.
   */
  byggar: number;
  /**
   * Pris för referensförsäljningen.
   */
  pris: number;
  /**
   * Pris per kvadratmeter för referensförsäljningen.
   */
  prisPerKvm: number;
  /**
   * Aktuellt pris för referensförsäljningen.
   */
  prisIdag: number;
  /**
   * Aktuellt pris per kvadratmeter för referensförsäljningen.
   */
  prisIdagPerKvm: number;
  /**
   * Datum för referensförsäljningen.
   */
  datum: DateAsString;
}

export interface Vardering {
  /**
   * Värdering.
   */
  vardering: number;
  /**
   * Kvalitet.
   */
  kvalitet: number;
  /**
   * Tidpunkt för värderingen.
   */
  tidpunkt: DateAsString;
}

export interface VarderingParametrarDto {
  /**
   * Unik identifierare för värderingsparametrarna.
   */
  id: string;
  adress: Adress;
  /**
   * X-koordinat (SWEREF99 TM).
   */
  sweref99x: number;
  /**
   * Y-koordinat (SWEREF99 TM).
   */
  sweref99y: number;
  kategori: Kategori;
  /**
   * Antal rum.
   */
  antalRum: number;
  /**
   * Boarea.
   */
  boarea: number;
  /**
   * Biarea.
   */
  biarea: number;
  /**
   * Tomtarea.
   */
  tomtarea: number;
  /**
   * Byggår.
   */
  byggar: number;
  /**
   * Avgift.
   */
  avgift: number;
  /**
   * Våning.
   */
  vaning: number;
  /**
   * Antal våningar.
   */
  antalVaningar: number;
  /**
   * Standardpoäng.
   */
  standardpoang: number;
}

export interface Links {}

export interface RepresentationModel<T> {
  links: Links;
}

export type DateAsString = string;

export const enum Agandeform {
  hyresrätt = 'HYRESRÄTT',
  tomträtt = 'TOMTRÄTT',
  bostadsrätt = 'BOSTADSRÄTT',
  okänd = 'OKÄND',
  äganderätt = 'AGANDERATT',
}

export const enum Bostadstyp {
  LAGENHET = 'LÄGENHET',
  OKAND = 'OKÄND',
  LANTBRUK_OVRIGA = 'LANTBRUK_ÖVRIGA',
  VILLA = 'VILLA',
  RADHUS = 'RADHUS',
  KEDJEHUS = 'KEDJEHUS',
  LANTBRUK = 'LANTBRUK',
  SMAHUS_OVRIGA = 'SMÅHUS_ÖVRIGA',
}

export const enum KallTyp {
  BOSTADSREGISTER = 'BOSTADSREGISTER',
  GEOKODNINGSTJANST = 'GEOKODNINGSTJANST',
}

export const enum Kategori {
  SMAHUS = 'SMAHUS',
  BOSTADSRATT = 'BOSTADSRATT',
}

export const enum ValidationText {
  NOT_NULL = 'NOT_NULL',
  WRONG_FORMAT = 'WRONG_FORMAT',
  MIN_VALUE = 'MIN_VALUE',
  MUST_BE_POSITIVE_OR_ZERO = 'MUST_BE_POSITIVE_OR_ZERO',
  MUST_BE_POSITIVE = 'MUST_BE_POSITIVE',
  MAX_VALUE = 'MAX_VALUE',
  BOAREA = 'BOAREA',
  BIAREA = 'BIAREA',
  TOMTAREA = 'TOMTAREA',
  AVGIFT = 'AVGIFT',
  ANTAL_VANINGAR = 'ANTAL_VANINGAR',
  STANDARDPOANG = 'STANDARDPOANG',
  BYGGAR = 'BYGGAR',
  SWEREF99X = 'SWEREF99X',
  SWEREF99Y = 'SWEREF99Y',
  KATEGORI = 'KATEGORI',
  ANTAL_RUM = 'ANTAL_RUM',
  GATA = 'GATA',
  POSTRORT = 'POSTRORT',
  POSTNUMMER = 'POSTNUMMER',
}
